<form [formGroup]="formData" novalidate>
  <div class="modal-header">
    <h4 class="modal-title">{{ pageTitle }}</h4>

    <!-- <div class="form-group">
			<input type="file" class="form-control-file" (change)="onFileUpload($event)">
		</div> -->

    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body go_team">
    <div class="row">
      <div class="col-md-8 po-client">
        <label for="">Client</label>
        <div class="input-group">
          <ng-select
            [items]="client$ | async"
            [addTag]="false"
            [multiple]="false"
            [hideSelected]="true"
            [trackByFn]="trackClientByFn"
            [loading]="clientLoading"
            [typeahead]="clientInput$"
            formControlName="client"
            (change)="setAddress(); refreshLineItems(); changeClient()"
          >
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
              <span
                class="ng-value-icon right"
                (click)="clear(item)"
                aria-hidden="true"
                >×</span
              >
              <span>
                {{ item.business_name }}
                <small *ngIf="item.user">
                  {{ item.user.firstname }} {{ item.user.lastname }}
                </small>
              </span>
            </ng-template>
            <ng-template
              ng-option-tmp
              let-item="item"
              let-index="index"
              let-search="searchTerm"
            >
              <h6>
                {{ item.business_name }}
                <small *ngIf="item.user">
                  {{ item.user.firstname }} {{ item.user.lastname }}
                </small>
              </h6>
            </ng-template>
          </ng-select>
          <div class="input-group-append">
            <button
              class="btn btn-outline-secondary"
              type="button"
              (click)="newClient()"
            >
              <i class="fas fa-plus"></i> New Client
            </button>
          </div>
        </div>
        <control-messages
          [submitted]="submitted"
          [control]="formData.controls.client"
        >
        </control-messages>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="" [translate]="'LABELS.CLIENT_PURCHASE_ORDER_DATE'"
            >Order Date</label
          >
          <input type="date" class="form-control" formControlName="order_date" />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.order_date"
          >
          </control-messages>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="" [translate]="'LABELS.CLIENT_PURCHASE_ORDER_TYPE'"
            >PO Type</label
          >
          <select formControlName="po_type" class="form-control">
            <option value="one_time">One-time</option>
            <option value="recurring">Recurring</option>
          </select>
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.po_type"
          >
          </control-messages>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <mat-checkbox color="primary" formControlName="will_affect_inventory">
            Affect Inventory
          </mat-checkbox>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="formData.value.po_type == 'recurring'">
      <div class="col-md-6">
        <div class="form-group">
          <label for="">Frequency</label>
          <select
            formControlName="recurring_type"
            class="form-control"
            (change)="setPoType()"
          >
            <option value="day">Daily</option>
            <option value="week">Weekly</option>
            <option value="month">Monthly</option>
            <option value="year">Year</option>
          </select>
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.recurring_type"
          >
          </control-messages>
        </div>
      </div>
      <div class="col-md-6" *ngIf="formData.value.recurring_type == 'week'">
        <div class="form-group">
          <label for="">Day of the Week</label>
          <select formControlName="day_weekly" class="form-control">
            <option value="monday">Monday</option>
            <option value="tuesday">Tuesday</option>
            <option value="wednesday">Wednesday</option>
            <option value="thursday">Thursday</option>
            <option value="friday">Friday</option>
            <option value="saturday">Saturday</option>
            <option value="sunday">Sunday</option>
          </select>
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.day_weekly"
          >
          </control-messages>
        </div>
      </div>
      <div class="col-md-6" *ngIf="formData.value.recurring_type == 'month'">
        <div class="form-group">
          <label for="">Day of the Month</label>
          <select formControlName="day_monthly" class="form-control">
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
            <option value="13">13</option>
            <option value="14">14</option>
            <option value="15">15</option>
            <option value="16">16</option>
            <option value="17">17</option>
            <option value="18">18</option>
            <option value="19">19</option>
            <option value="20">20</option>
            <option value="21">21</option>
            <option value="22">22</option>
            <option value="23">23</option>
            <option value="24">24</option>
            <option value="25">25</option>
            <option value="26">26</option>
            <option value="27">27</option>
            <option value="28">28</option>
            <option value="29">29</option>
            <option value="30">30</option>
            <option value="31">31</option>
          </select>
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.day_monthly"
          >
          </control-messages>
        </div>
      </div>
      <div class="col-md-6" *ngIf="formData.value.recurring_type == 'year'">
        <div class="form-group">
          <label for="">Day of the Year</label>
          <input type="date" class="form-control" formControlName="day_annually" />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.day_annually"
          >
          </control-messages>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="formData.value.po_type == 'recurring'">
      <div class="col-md-6">
        <div class="form-group">
          <label for="">End of Recurring PO</label>
          <select
            formControlName="is_limited_by_occurrence"
            (change)="changeRecurringEnding()"
            class="form-control"
          >
            <option value="0">Never</option>
            <option value="1">Occurrences</option>
          </select>
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.is_limited_by_occurrence"
          >
          </control-messages>
        </div>
      </div>
      <div class="col-md-6" *ngIf="formData.value.is_limited_by_occurrence == 1">
        <div class="form-group">
          <label for="">Maximum number of Occurrences</label>
          <input
            type="number"
            formControlName="max_occurrences"
            class="form-control"
          />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.max_occurrences"
          >
          </control-messages>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="formData.value.po_type == 'recurring'">
      <div class="col-md-6">
        <div class="form-group">
          <label
            for=""
            [translate]="'LABELS.RECURRING_CLIENT_PURCHASE_ORDER_PRICING'"
            >Recurring PO Pricing</label
          >
          <select formControlName="pricing_setting" class="form-control">
            <option value="default">Default</option>
            <option value="adjusting">Adjusting</option>
          </select>
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.pricing_setting"
          >
          </control-messages>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label for="">Delivery Type</label>
          <select
            formControlName="delivery_type"
            class="form-control"
            (change)="changeDeliveryType($event.target.value)"
          >
            <option
              *ngFor="let deliveryType of deliveryTypeLookUp"
              [value]="deliveryType.value"
            >
              {{ deliveryType.label }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-4" *ngIf="">
        <div class="form-group">
          <label>Select a Warehouse: </label>
          <select
            class="form-control"
            formControlName="warehouse_id"
            (change)="changeWarehouse($event.target.value)"
          >
            <option [value]="default_warehouse_id"></option>
            <option *ngFor="let w of warehouses" [value]="w.id">
              {{ w.location_name }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8">
        <div class="form-group">
          <label for="">Shipping Address</label>
          <input
            [readonly]="formData.controls.delivery_type.value == 'warehouse'"
            type="text"
            class="form-control"
            formControlName="ship_address"
          />
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="">City</label>
          <input
            [readonly]="formData.controls.delivery_type.value == 'warehouse'"
            type="text"
            class="form-control"
            formControlName="ship_city"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label for="">State</label>
          <input
            [readonly]="formData.controls.delivery_type.value == 'warehouse'"
            type="text"
            class="form-control"
            formControlName="ship_state"
          />
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="">Country</label>
          <input
            [readonly]="formData.controls.delivery_type.value == 'warehouse'"
            type="text"
            class="form-control"
            formControlName="ship_country"
          />
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="">Zip</label>
          <input
            [readonly]="formData.controls.delivery_type.value == 'warehouse'"
            type="text"
            class="form-control"
            formControlName="ship_zip"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label>Tags</label>
          <ng-select
            [items]="tags"
            formControlName="tags"
            bindValue="id"
            [searchFn]="customTagsSearchFn"
            multiple="true"
          >
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
              <span
                class="ng-value-icon right"
                (click)="clear(item)"
                aria-hidden="true"
                >×</span
              >
              <span [innerHTML]="item.name" class="d-inline"></span>
            </ng-template>
            <ng-template
              ng-option-tmp
              let-item="item"
              let-index="index"
              let-search="searchTerm"
            >
              <h6 [innerHTML]="item.name"></h6>
            </ng-template>
          </ng-select>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-between">
      <h5
        class="po-item-title mt-3"
        [translate]="'LABELS.CLIENT_PURCHASE_ORDER_LINE_ITEMS'"
      >
        Purchase Order Line Items
      </h5>

      <div class="form-group form-inline">
        <label>Upload</label>
        <input
          type="file"
          class="form-control mx-sm-3"
          (change)="onFileUpload($event)"
        />
        <small class="text-muted">
          <span class="upload-label"
            >(<a (click)="downloadTemplate()">Download Template</a>)</span
          >
        </small>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 text-right">
        <button
          class="btn btn-sm btn-outline-info btn-block"
          type="button"
          *ngIf="!this.is_overridden"
          (click)="toggleOverride()"
        >
          Override
        </button>
        <button
          class="btn btn-sm btn-warning btn-block"
          type="button"
          *ngIf="this.is_overridden"
          (click)="resetOverride()"
        >
          Reset Override
        </button>
      </div>
    </div>

    <table class="table table-striped">
      <thead>
        <tr>
          <th width="30%">Item(s)</th>
          <th>Quantity</th>
          <th>
            {{
              price_structure == 'Discount' ? 'Wholesale Price' : 'Material Cost'
            }}
          </th>
          <th>{{ price_structure }}</th>
          <th>(%)</th>
          <th class="text-nowrap">Line Total</th>
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody formArrayName="line_items">
        <tr
          *ngFor="
            let item of formData['controls'].line_items['controls'];
            let idx = index
          "
          [formGroupName]="idx"
        >
          <td [ngStyle]="{ maxWidth: '250px' }">
            <ng-select
              [items]="kitRfqs$ | async"
              [multiple]="false"
              [trackByFn]="trackByFn"
              appendTo="body"
              [clearable]="false"
              [loading]="rfqLoading"
              [typeahead]="rfqInput$"
              formControlName="item"
              [addTag]="addTagFn(idx)"
              name="rfqProduct"
              (change)="setPrice(idx)"
              addTagText="add item"
            >
              <ng-template ng-label-tmp let-item="item">
                <span *ngIf="item && item.id > 0">
                  [{{ item.sku }}] {{ item.product_name }}
                </span>
                <span *ngIf="item && item.id == 0">{{ item.product_name }}</span>
                <span *ngIf="item.is_discontinued == 1">
                  - <b class="text-warning"> DISCONTINUED</b></span
                >
                <span *ngIf="item.is_kit && item.is_kit == 1">
                  - <b class="text-info"> KIT</b></span
                >
              </ng-template>
              <ng-template
                ng-option-tmp
                let-item="item"
                let-index="index"
                let-search="searchTerm"
              >
                <span *ngIf="item && item.id > 0"
                  >[{{ item.sku }}] {{ item.product_name }}</span
                >
                <span *ngIf="item && item.id == 0">{{ item.product_name }}</span>
                <span *ngIf="item.is_discontinued == 1">
                  - <b class="text-warning"> DISCONTINUED</b></span
                >
                <span *ngIf="item.is_kit && item.is_kit == 1">
                  - <b class="text-info"> KIT</b></span
                >
              </ng-template>
            </ng-select>
          </td>
          <td class="text-right">
            <input
              type="number"
              formControlName="qty"
              (change)="computeLineTotal(idx, 'qty')"
              class="form-control"
            />
          </td>
          <td class="text-right">
            <input
              type="number"
              formControlName="price"
              (change)="computeLineTotal(idx, 'price')"
              class="form-control"
              *ngIf="this.is_overridden"
            />
            <span class="form-control" *ngIf="!this.is_overridden">{{
              formData.value.line_items[idx].price | currency: ' '
            }}</span>
          </td>
          <td class="text-right d-flex align-items-center">
            <input
              type="number"
              formControlName="discount"
              class="form-control"
              (input)="setDiscountManually(idx)"
              *ngIf="this.is_overridden"
            />
            <span class="form-control" *ngIf="!this.is_overridden">{{
              formData.value.line_items[idx].discount | currency: ' '
            }}</span>
          </td>
          <td [ngStyle]="{ maxWidth: '80px' }" class="align-middle">
            <div
              class="overflow-hidden d-flex align-items-center mx-1 text-nowrap"
              *ngIf="formData.value.line_items[idx].discount_percent"
            >
              {{ formData.value.line_items[idx].discount_percent.toFixed(2) }} %
            </div>
          </td>
          <td class="text-right">
            <span class="form-control">{{
              formData.value.line_items[idx].line_total | currency: ' '
            }}</span>
          </td>
          <td>
            <div ngbDropdown class="d-inline-block">
              <button
                ngbDropdownToggle
                mat-mini-fab
                type="button"
                color="default"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="flaticon-more-1"></i>
              </button>
              <div ngbDropdownMenu aria-labelledby="action-button">
                <button
                  ngbDropdownItem
                  type="button"
                  *ngIf="
                    formData.value.line_items[idx].item &&
                    formData.value.line_items[idx].item.id > 0 &&
                    price_structure == 'Discount' &&
                    this.is_overridden
                  "
                  (click)="
                    setDiscountStructure(formData.value.line_items[idx], idx)
                  "
                >
                  Set discount structure
                </button>
                <button
                  ngbDropdownItem
                  type="button"
                  *ngIf="
                    formData.value.line_items[idx].item &&
                    formData.value.line_items[idx].item.id > 0 &&
                    price_structure == 'Markup' &&
                    this.is_overridden
                  "
                  (click)="setMarkupStructure(formData.value.line_items[idx], idx)"
                >
                  Set markup structure
                </button>
                <button
                  type="button"
                  class="text-danger"
                  ngbDropdownItem
                  (click)="removeItem(idx)"
                >
                  Remove
                </button>
                <!-- <button type="button" ngbDropdownItem (click)="transferRfq();" title="Transfer SKU">
									<i class="fas fa-map-pin"></i> Transfer SKU
								</button>
								<button type="button" ngbDropdownItem (click)="exportRfqToPDF(rfq);" title="Export SKU">
									<i class="fas fa-file-pdf"></i> Export to PDF
								</button> -->
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="3" class="text-right">
            <h5>ORDER TOTAL:</h5>
          </td>
          <td>
            <h5 class="text-danger" *ngIf="price_structure == 'Discount'">
              -{{ total.discount | currency: ' ' }}
            </h5>
            <h5 class="text-success" *ngIf="price_structure == 'Markup'">
              +{{ total.discount | currency: ' ' }}
            </h5>
          </td>
          <td>&nbsp;</td>
          <td>
            <h5>{{ total.amount | currency: ' ' }}</h5>
          </td>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td colspan="7">
            <button
              type="button"
              class="btn btn-sm btn-info add-item"
              (click)="addItem()"
            >
              <i class="fas fa-plus"></i> Add Item
            </button>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-danger"
      *ngIf="
        purchaseOrder &&
        purchaseOrder.id &&
        purchaseOrder.overridden == 1 &&
        purchaseOrder.override_approved == 0 &&
        authService.loginUser.po_approval_permission == 1
      "
      (click)="rejectPo(purchaseOrder)"
    >
      <i class="fas fa-ban"></i> Reject PO
    </button>
    <button
      type="button"
      class="btn btn-outline-info"
      *ngIf="
        purchaseOrder &&
        purchaseOrder.id &&
        purchaseOrder.overridden == 1 &&
        purchaseOrder.override_approved == 0 &&
        authService.loginUser.po_approval_permission == 1
      "
      (click)="approvePo(purchaseOrder)"
    >
      <i class="fas fa-chevron-right"></i> Approve PO
    </button>
    <button
      type="button"
      class="btn btn-danger"
      (click)="activeModal.dismiss('')"
      [translate]="'BUTTONS.CLOSE'"
    >
      <i class="fas fa-times"></i> Close
    </button>

    <!-- <button type="button" (click)="onSubmit('DRAFT')"
			[ngClass]="{ 'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading }"
			[disabled]="loading" id="kt_submit" class="btn btn-primary btn-elevate kt-btn-primary">
			<i class="fas fa-save"></i> Draft
		</button>

		<button type="button" (click)="onSubmit('ACTIVE')"
			[ngClass]="{ 'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading }"
			[disabled]="loading" id="kt_submit" class="btn btn-success btn-elevate kt-btn-primary">
			<i class="fas fa-save"></i> Active
		</button> -->

    <div ngbDropdown placement="top-right" class="d-inline-block">
      <button
        class="btn btn-outline-success"
        id="dropdownBasic2"
        ngbDropdownToggle
        [disabled]="loading"
        [ngClass]="{
          'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--success':
            loading,
        }"
      >
        Save Purchase Order
      </button>
      <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
        <button ngbDropdownItem (click)="onSubmit('ACTIVE')">
          Mark as Active
        </button>
        <button ngbDropdownItem (click)="onSubmit('COMPLETED')">
          Mark as Complete
        </button>
        <div class="dropdown-divider"></div>
        <button ngbDropdownItem (click)="onSubmit('DRAFT')"> Save as Draft </button>
      </div>
    </div>
  </div>
</form>
